// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentRow_container__1u4YQ","fadeIn":"DocumentRow_fadeIn__2xN8t","icon":"DocumentRow_icon__3tCT8","title":"DocumentRow_title__3M268","info":"DocumentRow_info__2HWPs"};